import React from "react"
import { pageData } from "../../constants/pagedata";
import { StepOne } from "./stepone";
import { StepTwo } from "./steptwo";
import { StepThree } from "./stepthree";
import { StepFour } from "./stepfour";
import { StepFive } from "./stepfive";
import { StepSix } from "./stepsix";
import { CreateOutcome } from './createoutcome'
import { TaskDataMeta, TaskOption, TaskStatus, TaskListItem } from '../../types/tasks.types';

interface StateType {
	pageSelected: string,
	contentSelected: string[],
	taskTitle: string,
	taskTitleInput: string,
	welcomeMsg: string,
	pageOptions: TaskOption[],
	classCode: string,
	createStarted: boolean
}

interface PropsType {
	usermail: string,
	taskStatus: TaskStatus,
	userContentList: string[],
	tasksList: TaskListItem[],
	taskCreateClick: (createData: TaskDataMeta) => void,
	resetTaskStatus: () => void
}

const NOT_LOGGED_IN_MSG: React.ReactElement = <p className='teachers-statusmessage'>Not logged in</p>;

export default class CreateTask extends React.Component<PropsType> {

	public state: StateType;

	constructor(props: PropsType) {
		super(props);

		this.pageClick = this.pageClick.bind(this);
		this.contentClick = this.contentClick.bind(this);
		this.updateTitle = this.updateTitle.bind(this);
		this.classCodeAltered = this.classCodeAltered.bind(this);
		this.confirmCreateClick = this.confirmCreateClick.bind(this);
		this.updateOptions = this.updateOptions.bind(this);
		this.updateWelcomeMsg = this.updateWelcomeMsg.bind(this);
		this.resetClick = this.resetClick.bind(this);

		this.state = {
			pageSelected: '',
			contentSelected: ['', ''],
			taskTitle: '',
			taskTitleInput: '',
			welcomeMsg: '',
			pageOptions: [],
			classCode: '',
			createStarted: false
		}
	}

	pageClick(pageClicked: string) {
		if (this.state.createStarted) return;
		let newPageOptions: TaskOption[] = [];
		if (Object.keys(pageData[pageClicked]).includes('pageOptionsMeta')) {
			let myMeta = pageData[pageClicked].pageOptionsMeta;
			if (myMeta !== undefined) {
				for (let i = 0; i < myMeta.length; i++) {
					newPageOptions[i] = { optID: myMeta[i].optionsId, optVal: 0 };
				}
			}
		}
		if (pageClicked !== this.state.pageSelected) {
			this.setState({ pageSelected: pageClicked, contentSelected: ['', ''], pageOptions: newPageOptions });
		} else {
			this.setState({ pageSelected: '', contentSelected: ['', ''], pageOptions: newPageOptions });
		}
	}

	contentClick(contentSelected: string[]) {
		if (this.state.createStarted) return;
		if (contentSelected[0] === this.state.contentSelected[0] && contentSelected[1] === this.state.contentSelected[1]) {
			this.setState({ contentSelected: ['', ''] });
		} else {
			this.setState({ contentSelected: contentSelected });
		}
	}

	updateTitle(taskTitleInput: string, taskTitle: string) {
		if (this.state.createStarted) return;
		this.setState({ taskTitleInput: taskTitleInput, taskTitle: taskTitle });
	}

	classCodeAltered(inputText: string) {
		if (this.state.createStarted) return;
		let cleanText = inputText.replace(/[^a-zA-Z0-9._-]/g, "");
		// let cleanText = inputText.toLowerCase();
		// cleanText = cleanText.replace(/[^a-z0-9._-]/g, "");
		this.setState({ classCode: cleanText });
	}

	updateOptions(optID: string, optVal: number) {
		if (this.state.createStarted) return;
		let newOptions = this.state.pageOptions.map(option =>
			option.optID === optID ? { optID: optID, optVal: optVal } : option
		);
		this.setState({ pageOptions: newOptions });
	}

	updateWelcomeMsg(msg: string) {
		if (this.state.createStarted) return;
		this.setState({ welcomeMsg: msg });
	}

	confirmCreateClick() {
		this.setState({ createStarted: true });
		let createData: TaskDataMeta = {
			taskTitle: this.state.taskTitle,
			pageDir: pageData[this.state.pageSelected].pageDir,
			scoreType: pageData[this.state.pageSelected].scoreType,
			contentTitle: this.state.contentSelected[0],
			contentType: this.state.contentSelected[1],
			taskOptions: this.state.pageOptions,
			creatorMail: this.props.usermail,
			classCode: this.state.classCode,
			welcomeMsg: this.state.welcomeMsg,
			createdAt: ''
		};
		this.props.taskCreateClick(createData);
	}

	resetClick() {
		this.setState({
			pageSelected: '',
			contentSelected: ['', ''],
			taskTitle: '',
			taskTitleInput: '',
			welcomeMsg: '',
			pageOptions: [],
			classCode: '',
			createStarted: false
		});
		this.props.resetTaskStatus();
	}

	render() {
		if (this.props.usermail === '') return NOT_LOGGED_IN_MSG;

		return (
			<div id='teachers-tasks-create'>
				<hr />
				<h3>Create Task</h3>
				<hr />
				<div id='teachers-new-task'>
					<StepOne
						createStarted={this.state.createStarted}
						pageSelected={this.state.pageSelected}
						pageClick={this.pageClick}
						resetClick={this.resetClick}
					/>
					<StepTwo
						userContentList={this.props.userContentList}
						contentClick={this.contentClick}
						contentSelected={this.state.contentSelected}
						pageSelected={this.state.pageSelected}
					/>
					<StepThree
						createStarted={this.state.createStarted}
						taskTitle={this.state.taskTitle}
						taskTitleInput={this.state.taskTitleInput}
						tasksList={this.props.tasksList}
						updateTitle={this.updateTitle}
					/>
					<StepFour
						createStarted={this.state.createStarted}
						welcomeMsg={this.state.welcomeMsg}
						updateWelcomeMsg={this.updateWelcomeMsg}
					/>
					<StepFive
						classCode={this.state.classCode}
						classCodeAltered={this.classCodeAltered}
						tasksList={this.props.tasksList}
					/>
					<StepSix
						createStarted={this.state.createStarted}
						pageSelected={this.state.pageSelected}
						contentSelected={this.state.contentSelected}
						taskTitle={this.state.taskTitle}
						confirmCreateClick={this.confirmCreateClick}
						pageOptions={this.state.pageOptions}
						updateOptions={this.updateOptions}
					/>
					<CreateOutcome
						createStarted={this.state.createStarted}
						taskStatus={this.props.taskStatus}
						pageSelected={this.state.pageSelected}
						contentSelected={this.state.contentSelected}
						taskTitle={this.state.taskTitle}
						resetClick={this.resetClick}
						usermail={this.props.usermail}
					/>
				</div>
			</div>
		);
	}
}
